<template>
    <div class="header-contentys pt-3 d-flex align-items-center">
        <div class="mr-5">
            <h4 class="text-primary font-weight-bold">Déménagements ({{ lines }})</h4>
        </div>
        <div class="mr-4">
            <NavOperations></NavOperations>
        </div>
        <div class="btn-group page-nav mr-4" role="group" aria-label="Basic example">
            <a href="" class="btn " @click.prevent="changeAffichage('list')" :class="{ 'active': affichage === 'list' }">
                <i class="fa-solid fa-bars"></i>
            </a>
            <a href="" class="btn " @click.prevent="changeAffichage('cards')" :class="{ 'active': affichage === 'cards' }">
                <i class="fa-solid fa-border-all"></i>
            </a>
        </div>
        <div>
            <button type="button" class="btn-yams btn-active" @click="openCreateModal()">
                Ajouter un déménagement <i class="fa-solid fa-plus"></i>
            </button>
        </div>

    </div>
    <hr>
    <div class="body-contentys ">
        <p>
            <a class="btn btn-sm btn-secondary" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                <i class="fa-solid fa-bars mr-1"></i> Afficher les ressources
            </a>
        </p>
        <div class="collapse" id="collapseExample">
            <div class="card p-2 card-body mb-1 d-flex">
                <div class="d-flex">
                    <div class="mr-2">
                        <button type="button" class="btn btn-outline-dark" @click="openIndexFormule()" v-if="getPermission('voir-trajets') === true">
                            <i class="fa-solid fa-bars"></i> Formule
                        </button>
                    </div>
                    <div class="mr-2">
                        <button type="button" class="btn btn-outline-dark" @click="openIndexType()" >
                            <i class="fa-solid fa-bars"></i> Type déménagement
                        </button>
                    </div>
                    <div class="mr-2">
                        <button type="button" class="btn btn-outline-dark" @click="openIndexLogement()" >
                            <i class="fa-solid fa-bars"></i> Type logement
                        </button>
                    </div>
                    <div class="mr-2">
                        <button type="button" class="btn btn-outline-dark" @click="openIndexTarif()" >
                            <i class="fa-solid fa-bars"></i> Tarif
                        </button>
                    </div>
                    <div class="mr-2">
                        <button type="button" class="btn btn-outline-dark" @click="openIndexZone()" >
                            <i class="fa-solid fa-bars"></i> Zone
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <DataTableBackend url="/api/demenagements" :columns="columns" :affichage="affichage" :table="table" :idParams="this.$route.params.id" selection inCard
        v-on:set-total-records="updateLines">
            <template #action_group_btns=slotProps>
                <button type="button" class="btn btn-sm btn-danger mr-2" @click="deleteGroup(slotProps.data)">
                    <i class="fas fa-trash-alt"></i> Supprimer
                    <span v-if="isLoading == true" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>
            </template>
            <template #action_btns=slotProps>
                <button class="btn btn-sm btn-outline-dark" @click="openShowModal(slotProps.data)">
                    <i class="fa-solid fa-eye"></i>
                </button>
            </template>
        </DataTableBackend>

    </div>
</template>
  
<script >
import $ from "jquery"
import { defineComponent, defineAsyncComponent } from 'vue';
import NavOperations from '../../NavOperations.vue';
const CreateDemenagement = defineAsyncComponent(() => import('./CreateDemenagement.vue'));
const ShowDemenagement = defineAsyncComponent(() => import('./ShowDemenagement.vue'));
const IndexFormule = defineAsyncComponent(() => import('./formule/IndexFormule.vue'));
const IndexType = defineAsyncComponent(() => import('./type_demenagement/IndexType.vue'));
const IndexLogement = defineAsyncComponent(() => import('./type_logement/IndexLogement.vue'));
const IndexTarif = defineAsyncComponent(() => import('./tarif/IndexTarif.vue'));
const IndexZone = defineAsyncComponent(() => import('./zone/IndexZone.vue'));

export default defineComponent({
    name: 'IndexCourse',
    components: { NavOperations },
    data() {
        return {
            lines: 0,
             key:1,
            affichage: "list",
            table: 'demenagements',
            columns: [
                {
                    key: 'created_at',
                    label: 'Enregistré le',
                    exportable: true
                },
                {
                    key: 'demenagement_tarif.formule.libelle',
                    label: 'Formule',
                    exportable: true
                },
                {
                    key: 'demenagement_tarif.types_demenagement.libelle',
                    label: 'Type',
                    exportable: true
                },
                {
                    key: 'demenagement_tarif.types_logement.libelle',
                    label: 'Logement',
                    exportable: true
                },
                {
                    key: 'demenagement_zone.libelle',
                    label: 'Trajet',
                    exportable: true
                },
                {
                    key: 'montant',
                    label: 'Montant',
                    format: 'money',
                    exportable: true
                },
                {
                    key: 'statut',
                    label: 'Etat',
                    format: 'state'
                }
            ]
        };
    },
    methods: {
        getPermission(permission) {
            return this.$store.getters.permissions.includes(permission)
        },
        changeAffichage(type) {
            this.affichage = type;
            this.key++
        },
        openIndexFormule() {
            this.$dialog.open(IndexFormule, {
                props: {
                    header: "Formule",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        openIndexType() {
            this.$dialog.open(IndexType, {
                props: {
                    header: "Types",
                    style: {
                        width: '80vw'
                    },
                    modal: true
                }
            });
        },
        openIndexLogement() {
            this.$dialog.open(IndexLogement, {
                props: {
                    header: "Logements",
                    style: {
                        width: '80vw'
                    },
                    modal: true
                }
            });
        },
        openIndexTarif() {
            this.$dialog.open(IndexTarif, {
                props: {
                    header: "Tarif",
                    style: {
                        width: '80vw'
                    },
                    modal: true
                }
            });
        },
        openIndexZone() {
            this.$dialog.open(IndexZone, {
                props: {
                    header: "Zone",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        openCreateModal() {
            this.$dialog.open(CreateDemenagement, {
                props: {
                    header: "Nouveau déménagement",
                    style: {
                        width: '50vw'
                    },
                    modal: true
                }
            });
        },
        openShowModal(objData) {
            this.$dialog.open(ShowDemenagement, {
                props: {
                    header: "Déménagement  0" + objData.id,
                    style: {
                        width: '50vw'
                    },
                    modal: true
                },
                data: objData
            });
        },
        deleteGroup(selection) {
            if (!window.confirm("Etes vous sur de vouloir supprimer ?")) {
                return
            }

            this.isLoading = true
            let selectedLines = []
            for (let index = 0; index < selection.length; index++) {
                const element = selection[index];
                selectedLines.push(element.id)
            }

            this.axios.post('/api/demenagements/destroy-group', { selected_lines: selectedLines }).then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    $('#refresh' + this.table).click()
                    for (let index = 0; index < response.data.message.length; index++) {
                        const element = response.data.message[index];
                        this.$toast.add({
                            severity: element.severity,
                            detail: element.value,
                            life: parseInt(5000 * (index + 1))
                        });
                    }
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        updateLines(nb_lines) {
            this.lines = nb_lines
        }
    }
});
</script>